/*
    © 2021 EcomGraduates
    Predictive search via /search/suggest (section rendering API)
*/

const PREDICTIVE_SEARCH_SECTION_ID = 'predictive-search-section';

let swiperInstance = null;

const swiperInit = (amountProducts) => {
  if (swiperInstance) {
    swiperInstance.destroy();
  }

  if (window.innerWidth < 769) {
    swiperInstance = new Swiper('.searchResultsMobile', {
      navigation: amountProducts > 2 ? {
        nextEl: '.swiper-button-next-mob',
        prevEl: '.swiper-button-prev-mob',
      } : false,
      slidesPerView: 2,
      grid: {
        rows: 2,
        fill: 'row',
      },
      spaceBetween: 16,
      loop: false,
      allowTouchMove: amountProducts > 2,
    });

    if (amountProducts <= 2) {
      document.querySelectorAll('.swiper-header-arrows-mob')[1].style.display = 'none';
    } else {
      document.querySelectorAll('.swiper-header-arrows-mob')[1].style.display = 'flex';
    }
  } else {
    swiperInstance = new Swiper('.searchResultsDesktop', {
      navigation: amountProducts > 4 ? {
        nextEl: '.swiper-button-next-deskt',
        prevEl: '.swiper-button-prev-deskt',
      } : false,
      slidesPerView: 4,
      spaceBetween: 16,
      loop: false,
      allowTouchMove: amountProducts > 4,
    });

    if (amountProducts <= 4) {
      document.querySelector('.swiper-button-next-deskt').style.display = 'none';
      document.querySelector('.swiper-button-prev-deskt').style.display = 'none';
    } else {
      document.querySelector('.swiper-button-next-deskt').style.display = 'flex';
      document.querySelector('.swiper-button-prev-deskt').style.display = 'flex';
    }
  }
};

const parsePredictiveSearchSection = (html) => {
  const sectionEl = new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(`#shopify-section-${PREDICTIVE_SEARCH_SECTION_ID}`);

  if (!sectionEl) {
    return null;
  }

  return sectionEl.querySelector('#predictive-search-section-results');
};

function handleInputChange(
  inputSelector,
  listSelector,
  modalFooterSelector
) {
  const modalFooter = document.querySelector(modalFooterSelector);
  let topSuggestionsElement;
  let searchResultsHeading;

  if (window.innerWidth < 769) {
    topSuggestionsElement = document.querySelector('#top-suggestions-menu-mobile');
    searchResultsHeading = document.querySelector('#search-results-heading-mobile');
  } else {
    topSuggestionsElement = document.querySelector('#top-suggestions-menu-desktop');
    searchResultsHeading = document.querySelector('#search-results-heading-desktop');
  }

  const swiperWrapper = document
    .querySelector(listSelector)
    .querySelector('.swiper-wrapper');

  document.querySelector(inputSelector)?.addEventListener(
    'input',
    window.debounce((e) => {
      const list = document.querySelector(listSelector);

      if (e.target.value.length === 0) {
        list.parentElement.style.display = 'none';
        topSuggestionsElement.style.display = 'block';
        if (modalFooter) {
          modalFooter.style.display = 'none';
        }
        return;
      }

      const query = encodeURIComponent(e.target.value);
      const limit = e.target.dataset.limit;
      const url = `/search/suggest?q=${query}&resources[type]=product&resources[limit]=${limit}&resources[options][unavailable_products]=last&section_id=${PREDICTIVE_SEARCH_SECTION_ID}`;

      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`${response.status}: ${response.statusText}`);
          }
          return response.text();
        })
        .then((html) => {
          const resultsEl = parsePredictiveSearchSection(html);

          if (!resultsEl || resultsEl.dataset.hasResults !== 'true') {
            list.parentElement.style.display = 'none';
            topSuggestionsElement.style.display = 'block';
            if (modalFooter) {
              modalFooter.style.display = 'none';
            }
            return;
          }

          const visibleCount = Number(resultsEl.dataset.productCount) || 0;
          const totalCount = Number(resultsEl.dataset.totalCount) || 0;

          searchResultsHeading.innerText = `Search results (${visibleCount})`;

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'search',
            search_term: e.target.value,
            results_count: visibleCount
          });

          if (swiperWrapper) {
            swiperWrapper.innerHTML = resultsEl.innerHTML;
          } else {
            list.innerHTML = resultsEl.innerHTML;
          }

          list.parentElement.style.display = 'block';
          topSuggestionsElement.style.display = 'none';
          swiperInit(totalCount);

          if (modalFooter) {
            modalFooter.style.display = totalCount === Number(limit) ? 'block' : 'none';
          }
        })
        .catch((error) => {
          console.error('Predictive search error:', error);
          list.parentElement.style.display = 'none';
          topSuggestionsElement.style.display = 'block';
          if (modalFooter) {
            modalFooter.style.display = 'none';
          }
        });
    }, 200)
  );
}

handleInputChange(
  '#predictive-search-input-mobile',
  '#predictive-search-list-mobile',
  '#modal-search-mobile .modal-footer'
);

handleInputChange(
  '#predictive-search-input-desktop',
  '#predictive-search-list-desktop',
  '#modal-search-desktop .modal-footer'
);
